import { deviceConstants } from './device.constants';

export const setDeviceData = (type, payload) => {
    return dispatch => {
        dispatch(
            {
                type: type,
                payload: payload
            })
    };
}

export const setLogin = (name, isActive) => {
    return dispatch => {
        dispatch(
            {
                type: deviceConstants.DEVICE,
                payload: {
                    name,
                    isActive
                }
            })
    };
}